import React from 'react';
import { Link } from 'react-router-dom';

import '../../../commonStyles/CommonRouteStyles.css'
import '../../../platform/navigation/EdgeNavigation.css'

export default function Kitchen() {

    return (
        <section id='Kitchen-Section'>

            <div className='Edge-Section-Position-Left Edge-Section-Flex Edge-Section-Dimensions'>
                <Link to="/" className='Edge-Button-Dimension'>
                    <button className="EdgeButtons-Colors Edge-Button-Dimension"></button>
                </Link>
            </div>

            <div id="HomeRoute-Header" className='HomeRoute-Header-Title-Section-Dimensions HomeRoute-Header-Title-Section-Position'>
                <button id='Photo-Gallery-Header-Title' className='HomeRoute-Header-Color HomeRoute-Header-Animation-Open HomeRoute-Header-Dimensions HomeRoute-Header-Shape'>
                    <h1>David Crockett</h1>
                </button>
            </div>

            <div className='Content-Section-Position Content-Section-Shape Content-Section-Color Content-Section-Dimesions'>

                <h2>
                    David Crockett
                    Phone: (801) 350-1056 | Email: david.crockett.1069@gmail.com | Salt Lake City, UT, 84081
                    LinkedIn: https://www.linkedin.com/in/david-crockett-252497211/ | Portfolio: https://romantic-stonebraker-e56dd1.netlify.app/ | GitHub:  https://github.com/CastroOlympias
                </h2>

                <br /> <br />
                <h2>
                    Full Stack Web Developer and a creative problem solver with great ideas for solutions, while wearing all 3 hats, as a user, designer and developer. Very professional, high quality in mind for creating new applications, and providing exceptional customer service.
                </h2>
                <br /> <br />
                <h2>
                    TECHNICAL SKILLS
                </h2>
                <br />
                <h3>
                    Languages: JavaScript ES6+, CSS3, HTML5, SQL, NoSQL
                    Applications: GitHub, MongoDB, MySQL, Heroku, Netlify, MongoDB Atlas
                    Tools: Express, React, Node, Sequelize, Mongoose, GraphQl, REST APIs Handlebars
                </h3>
                <br /> <br />
                <h2>
                    PROJECTS
                </h2>
                <br />
                <h3>
                    Trinity-focus-energy | https://castro-olympias-trinity.herokuapp.com/
                </h3>
                <h3>
                    •	Summary: Meal prepping, tracking macro, cost, and workouts
                    <br />
                    •	Role: Sole author
                    <br />
                    •	Tools: HTML, CSS, JavaScript, Apollo-Server-Express, GraphQl, MERN Stack
                </h3>
                <br />
                <h3>
                    JavaScriptKingdom | https://github.com/CastroOlympias/javaScriptKingdom | https://castroolympias.github.io/javaScriptKingdom/
                </h3>
                <h3>
                    •	Summary: Java Script tool box & testing of front-end behavior animations
                    <br />
                    •	Role: Sole author
                    <br />
                    •	Tools: HTML, CSS, JavaScript
                </h3>

                <br />
                <h3>
                    The-underground | https://the-underground-castro.herokuapp.com/ |
                </h3>
                <h3>
                    •	Summary: Looking for non-main stream entertainment or set up a show?
                    <br />
                    •	Role: Collaborated with the backend and front-end development
                    <br />
                    •	Tools: MERN Stack, Apollo-Server-Express, GraphQl, React-bootstrap
                </h3>

                <br /> <br />
                <h2>
                    EXPERIENCE
                </h2>
                <br />
                <h3>
                    Junior Web Developer
                    <br />
                    2021-Present
                    <br />
                    Salt Lake City, UT
                </h3>
                <br />
                <h3>
                    the-underground
                </h3>
                <h3>
                    This is a Coding Bootcamp project that we are continuing to develop to serve the needs of artists and fans alike who are not main-stream, allowing them to connect with their audience and other artists.
                    <br />
                    •	Co-developing an application where artists and fans can enjoy a rich user experience and a digital space, where they will be able to arrange for in-live performances.
                    <br />
                    •	Artists will be able to avoid the main-stream, promote themselves and sell their own shows and we’ll help them become profitable.
                </h3>
                <br />

                <h3>
                    Expeditors International of Washington
                </h3>
                <br />
                <h3>
                    2006-Current
                    <br />
                    Salt Lake City, UT
                    <br />
                    Maintained a high-level of export customs compliance with regulations, helping our customers understand regulatory documentation, configuring their costs and export declarations.
                    Key Accomplishments:
                    <br />	<br />
                    •	Initiated work with a developer to get me data which allowed for the creation of a chassis billing tool in excel, to calculate up to 13 charges, depending on when a container was picked up, delivered and returned empty, based on data, with formulas to crunch the numbers. This allowed us to reduce the number of additional bills to our customers. Billing based on data instead of months later after receiving invoices from vendors. Improved customer billing, AR, revenue flow, and auditing against our contracts with our vendors.
                    <br />	<br />
                    •	Led a team with a developer and account managers to create a process hold for compliance issues to record extra work required to process shipments, while calculating cost estimates of $1500/month, enabling rate increases where appropriate as well as providing targeted topics and materials for training our customers.
                    <br />	<br />
                    •	Built an excel workbook using macros, and formulas to better track and update shipment data, utilizing formulas to affect other data based on routing type and average transit times, e.g. East coast rail versus west coast rail or east coast motor-bridge versus west coast motor-bridge, etc. This created much better visibility in shipments milestones for tracking and updating progress from origin to final delivery. It greatly improved timely customs clearance, and payment to steamship lines and saved from having to pay out storage as non-recoverable expenses due to incorrect ETA data.
                </h3>
                <br />	<br />

                <h2>
                    EDUCATION
                </h2>
                <br />
                <h3>
                    Certificate in Full Stack Web Development – University of Utah
                    <br />
                    March – August 2021
                    <br />
                    Salt Lake City, UT
                    <br />
                    Recent graduate of the Coding Boot Camp from the University of Utah with a 98.35% score.
                </h3>

            </div>

            <a href={require(`../../../assets/documents/David_Crockett_Full_Stack_Web_Developer.pdf`)} target="_blank" rel="noopener noreferrer">
                <button id="HomeRoute-NavigationButton" className='HomeRoute-NavigationButton-Color HomeRoute-NavigationButton-Animation-Open HomeRoute-NavigationButton-Shape HomeRoute-NavigationButton-Position HomeRoute-NavigationButton-Dimensions'><p id="HomeRoute-NavigationButton-PTag-Text" className='HomeRoute-NavigationButton-PTag-Text'>Download PDF</p></button>
            </a>

            <div className='Edge-Section-Position-Right Edge-Section-Flex Edge-Section-Dimensions'>
                <Link to="/" className='Edge-Button-Dimension'>
                    <button className="EdgeButtons-Colors Edge-Button-Dimension"></button>
                </Link>
            </div>

        </section>

    )
}